// webfunny监控、埋点平台数据支持 mixin

// 项目版本
const uVersion = '1.0.1'

// webfunny local-uuid key
const uuidLocalKey = `wfuuid_${uVersion}`

/** 生成uuid */
const genNewUuid = function () {
  let s = []
  let hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[8] = s[13] = s[18] = s[23] = '-'
  const _uuid = s.join('')
  // 本地缓存
  window.localStorage.setItem(uuidLocalKey, _uuid)
  return _uuid
}


// 缓存 uuid
const uuid = window.localStorage[uuidLocalKey] || genNewUuid()

// 监控平台缓存用户数据， userTag 和 projectVersion 可自行定义规则
window.localStorage.wmUserInfo = JSON.stringify({ userId: uuid, userTag: 'baoH5', projectVersion: uVersion })

export default {
  data: function () {
    return {
      // 埋点所需uuid
      wfuuid: uuid,
    }
  }
}